import { Colors } from "./types";

export const baseColors = {
    failure: "#ED4B9E",
    primary: "#CD63FF",
    primaryBright: "#53DEE9",
    primaryDark: "#0098A1",
    secondary: "#7645D9",
    success: "#31D0AA",
    warning: "#FFB237",
};

export const brandColors = {
    binance: "#F0B90B",
};

export const lightColors: Colors = {
    ...baseColors,
    ...brandColors,
    background: "#02052E",
    backgroundDisabled: "#E9EAEB",
    backgroundAlt: "#FFFFFF",
    text: "#FFFFFF",
    textDisabled: "#CECECE",
    textSubtle: "#02052E",
    borderColor: "rgba(205, 99, 255, 0.1)",
    imgBackgroundColor: "rgba(129, 0, 190, 0.1)",
    gamefiSubHeadingColor: "#B8B8B8",
    footerLink: "#CECECE",
    socialIcons: "rgba(205,99,255,0.2)",
    inputBackground: "#F4F4F4",
};

export const darkColors: Colors = {
    ...baseColors,
    ...brandColors,
    secondary: "#9A6AFF",
    background: "#100C18",
    backgroundDisabled: "#3c3742",
    backgroundAlt: "#27262c",
    primaryDark: "#0098A1",
    text: "#FFFFFF",
    textDisabled: "#CECECE",
    textSubtle: "#02052E",
    borderColor: "rgba(205, 99, 255, 0.1)",
    imgBackgroundColor: "rgba(129, 0, 190, 0.1)",
    gamefiSubHeadingColor: "#B8B8B8",
    footerLink: "#CECECE",
    socialIcons: "rgba(205,99,255,0.2)",
    inputBackground: "#F4F4F4",
};
